import { render, staticRenderFns } from "./privacyAgreement.vue?vue&type=template&id=27c6de7e&scoped=true&"
import script from "./privacyAgreement.vue?vue&type=script&lang=js&"
export * from "./privacyAgreement.vue?vue&type=script&lang=js&"
import style0 from "./privacyAgreement.vue?vue&type=style&index=0&id=27c6de7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c6de7e",
  null
  
)

export default component.exports